<template>
    <component
        :is="link ? 'a' : 'div'"
        v-on="$listeners"
        :href="link"
        class="card-scale"
    >
        <img
            v-if="image"
            :src="image"
            :alt="title"
            class="card-scale__image"
        />
        <div class="card-scale__content">
            <z-logo
                isIndex
                site-dir="/"
                :inverted="logoInverted"
                class="card-scale__logo"
            />
            <p
                v-if="title"
                class="card-scale__title"
                v-html="title"></p>
        </div>
    </component>
</template>

<script>
export default {
    name: 'card-scale',
    props: {
        title: String,
        image: String,
        showLogo: {
            type: Boolean,
            default: true
        },
        logoInverted: {
            type: Boolean,
            default: true
        },
        link: String
    }
}
</script>

<style lang="scss">
.card-scale {
    $parent: &;
    display: block;
    border-radius: 0px 40px 0px 20px;
    position: relative;
    overflow: hidden;

    &:hover {
        #{$parent}__image {
            transform: scale(1.5);
        }
        #{$parent}__content {
            transform: translateX(13px);
        }
    }

    &__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s ease-in-out;
        user-select: none;
    }

    &__content {
        position: absolute;
        left: 47px;
        bottom: 29px;
        transition: transform 0.6s ease-in-out;
    }

    &__logo {
        &.z-logo {
            width: 95px;
            height: 20px;
            @include margin-level(bottom, 2XS);
        }
    }

    &__title {
        @include typo-level(3XL);
        color: $token-colors-white;
        line-height: 0.9;
    }
}
</style>
